export class Notes {
    description: String;
    createdBy: String;
    createdOn: any;
    duration: any;
}